import FacetsDecorator from './facets-decorator';
import Helpers from './helpers';
import Interactions from './interactions';

const CollapsibleFilters = {
  FacetsDecorator,
  Helpers,
  Interactions
};

export default CollapsibleFilters;